import { Component, Inject, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContentObserver } from '@angular/cdk/observers';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { UserDetailsService } from 'src/app/services/user-details.service';


@Component({
  selector: 'business-cd-lov',
  templateUrl: './business-cd-lov.component.html',
  styleUrls: ['./business-cd-lov.component.css']
})
export class BusinessCodeLovDialogComponent implements OnInit {

  userTypeModuleId: string = 'BMM187';

  constructor(private apiCallService: APICallService,
    private jsonDataService: JsonDataService,
    private securityService: SecurityService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<BusinessCodeLovDialogComponent>) { }
  
  ngOnInit(): void {
    this.getUserType();
  }


  // Variable Initializer
  issueSourceData: any = [];

  // Issue Source Initializer
  businessTableConfig: any = {
    cols: [
      {
        key: "BUSINESS_CD",
        header: "Code",
        dataType: "string",
        width: '15%'
      },
      {
        key: "BUS_NAME",
        header: "Description",
        dataType: "string",
        width: '30%'
      },
      {
        key: "BM_CODE",
        header: "BPIMS Code",
        dataType: "string",
        width: '30%'
      },
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15
  }

  // Gets data for Issue Source Table
  getUserType() {
    try {
      /*
      this.businessTableConfig.loading = true;
      this.issueSourceData = await this.apiCallService.getAllIssueSource().toPromise();
      this.issueSourceData = this.issueSourceData.content;
      this.businessTableConfig.loading = false;
      this.businessTableConfig.tblData = this.issueSourceData;
      */
      this.businessTableConfig.loading = true;
      this.jsonDataService.contorlLoading(true);
      this.apiCallService.getBusinessCode({
        moduleId: this.data.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe((data: any) => {
            this.securityService.checkRequestKeyResponse(data, () => {
              this.securityService.hasValidCsrfToken(data, () => {
                if (data.status === "SUCCESS") {
                  data = JSON.parse(this.jsonDataService.decrypt(data.response));
                  this.jsonDataService.contorlLoading(false);
                  this.businessTableConfig.loading = false;
                  this.businessTableConfig.tblData = data.filter((e: any) => e.ACTIVE_TAG == 'A');
                } else {
                    this.jsonDataService.contorlLoading(false);
                    this.businessTableConfig.loading = false;
                    this.appMessageService.showAppMessage(data.message, "error");
                }
              });
            });
      });
    } 
    catch(e) {
      
    }
  }

  onRowClick(ev: any) {
    try {
      this.data = ev;
    }
    catch(e) {
      
    }
  }

  onClose() {
    try {
      if(this.data=='' || this.data==null){
        this._dialogRef.close({content: ''}); 
      } else {
        this._dialogRef.close({content: this.data, moduleId: this.data.moduleId});
      }
    }
    catch(e) {
      
    }
  }

  onBack() {
    try {
      this._dialogRef.close({content: '', option: 'back'});
    }
    catch(e) {
      
    }
  }

}

